export  function postCarousel() {
    $(".post-carousel").each(function () {
        let curSliderWrap = $(this);
        let curSlider = curSliderWrap.find(".swiper-container");
		
        let swiperOptions = {
            watchOverflow: true,
            spaceBetween: 0,
            slidesPerView: 1,
            navigation: {
                nextEl: `.${curSliderWrap.find(".swiper-button-next").attr("class")}`,
                prevEl: `.${curSliderWrap.find(".swiper-button-prev").attr("class")}`,
            },
            pagination: {
                el: `.${curSliderWrap.find(".swiper-pagination").attr("class")}`,
                clickable: true,
            }
        };

        let swiper = new Swiper(`.${curSlider.attr("class")}`, swiperOptions);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/postCarousel.js